__turbopack_context__.v({
  "actionButton": "tenantResearchRoomStyles-module-scss-module__IJ3AVG__actionButton",
  "bookDemoButton": "tenantResearchRoomStyles-module-scss-module__IJ3AVG__bookDemoButton",
  "largeLogo": "tenantResearchRoomStyles-module-scss-module__IJ3AVG__largeLogo",
  "lgContainer": "tenantResearchRoomStyles-module-scss-module__IJ3AVG__lgContainer",
  "mdContainer": "tenantResearchRoomStyles-module-scss-module__IJ3AVG__mdContainer",
  "mobileMenu": "tenantResearchRoomStyles-module-scss-module__IJ3AVG__mobileMenu",
  "narrowContainer": "tenantResearchRoomStyles-module-scss-module__IJ3AVG__narrowContainer",
  "pageContainer": "tenantResearchRoomStyles-module-scss-module__IJ3AVG__pageContainer",
  "secondaryBtn": "tenantResearchRoomStyles-module-scss-module__IJ3AVG__secondaryBtn",
  "sectionDescription": "tenantResearchRoomStyles-module-scss-module__IJ3AVG__sectionDescription",
  "sectionTitle": "tenantResearchRoomStyles-module-scss-module__IJ3AVG__sectionTitle",
});
